module.exports = __webpack_public_path__ + "static/img/csybh.cffc4178.png";